<div class="form-group">
  <button (click)="fileInput.click()" mat-flat-button color="default">
    Select file
    <input (change)="uploadFile($event)" type="file" #fileInput name="..." />
  </button>
</div>
@if (files.length > 0) {
  <div class="mt-2">
    @for (file of files; track file) {
      <a href="{{ file.publicUrl }}" download>
        {{ file.name }} <i class="la la-times" (click)="deleteFile(file.id)"></i>
      </a>
    }
  </div>
}
